/**
 * Mixin that ensures disconnectedCallback also fires before Turbo caches the
 * page for back navigation. Without this, the DOM snapshot contains leftover
 * state (injected nodes, third-party widget wrappers) but without the
 * JavaScript properties and event listeners — causing duplicates or broken
 * components on restore.
 *
 * Usage:
 *   import { withTurbo } from './with-turbo'
 *   export default class MyElement extends withTurbo(HTMLElement) { ... }
 *
 *   // or for wrapping external classes:
 *   customElements.define('my-element', withTurbo(ExternalClass))
 */
export const withTurbo = (Base) =>
  class extends Base {
    connectedCallback() {
      this._beforeCacheHandler = () => this.disconnectedCallback()
      document.addEventListener('turbo:before-cache', this._beforeCacheHandler)
      super.connectedCallback()
    }

    disconnectedCallback() {
      document.removeEventListener(
        'turbo:before-cache',
        this._beforeCacheHandler
      )
      super.disconnectedCallback?.()
    }
  }
